import * as React from 'react';
import {cn} from '@/lib/utils';

const Layout = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({className, ...props}, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col h-screen w-full', className)}
    {...props}
  />
));
Layout.displayName = 'Layout';

const Header = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({className, ...props}, ref) => (
  <header
    ref={ref}
    className={cn(
      'flex items-center justify-between px-4 py-2 border-b bg-background -h-header',
      className,
    )}
    {...props}
  />
));
Header.displayName = 'Header';

const Content = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({className, ...props}, ref) => (
  <main
    ref={ref}
    className={cn('flex-1 overflow-auto -h-body', className)}
    {...props}
  />
));
Content.displayName = 'Content';

export {Layout, Header, Content};
